import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const departmentSaleStyles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  departmentSaleTitleContainer: {
    height: '8.8vh',
  },
  departmentSaleTitleBar: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  departmentSaleTitleHeader: {
    color: themeColor.modalTitle,
  },
  departmentSaleTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  departmentSaleWeightLabel: {
    fontSize: vh(3.187250996015936),
    fontWeight: 500,
  },
  departmentSaleTitleWeightContainer: {
    width: 'fit-content',
    height: 'fit-content',
    alignSelf: 'flex-end',
  },
  departmentSaleContainer: {
    padding: 10,
  },
  selectDepartmentSubheading: {
    fontWeight: 500,
    lineHeight: '2.65vh',
    fontSize: vh(2.39),
  },
  departmentCard: {
    width: '11.713vw',
    height: '9.1146vh',
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    marginRight: '0.797vh',
    cursor: 'pointer',
    marginBottom: '0.797vh',
    padding: '1.04vh',
  },
  departmentCardHeader: {
    fontSize: vh(2.12),
    lineHeight: '2.39vh',
    fontWeight: 500,
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  departmentCardSubheader: {
    fontSize: vh(1.5936),
    lineHeight: '1.125vh',
    fontWeight: 500,
    textAlign: 'center',
    color: themeColor.subheaderLight,
  },
  departmentCardContainer: {
    marginTop: '3.12vh',
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  button: {
    fontSize: vh(2.1248),
  },
  cancelButton: {
    marginRight: '1.3280vh',
  },
  priceUnit: {
    height: 'fit-content',
    alignSelf: 'flex-end',
    marginLeft: '1.328vh',
  },
  departmentIdLabel: {
    fontSize: vh(2.39),
    fontWeight: 500,
  },
  departmentIdValue: {
    fontSize: vh(2.656),
    fontWeight: 500,
  },
  departmentDescription: {
    fontSize: vh(2.1248339973439574),
    color: themeColor.subheaderLight,
    marginTop: '2.6560424966799467vh',
    fontWeight: 500,
  },
  priceLabel: {
    fontSize: vh(2.1248339973439574),
    fontWeight: 500,
  },
  priceLabelContainer: {
    height: 'fit-content',
    alignSelf: 'center',
  },
  approvalPriceInput: {
    width: '13.678618857901727vh',
    fontSize: vh(2.9216467463479416),
  },
  underline: {
    '&:before': {
      borderBottom: `0.398406374501992vh solid ${theme.palette.secondary.main}`,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
    },
    '&:after': {
      borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
    },
  },
  inputTextCenter: {
    textAlign: 'center',
  },
}));
